export const colors = [
  {
    bgColor: 'bg-pink-500',
    fillColor: 'bg-pink-600',
  },
  {
    bgColor: 'bg-sky-500',
    fillColor: 'bg-sky-600',
  },
  {
    bgColor: 'bg-orange-500',
    fillColor: 'bg-orange-600',
  },
  {
    bgColor: 'bg-green-500',
    fillColor: 'bg-green-600',
  },
  {
    bgColor: 'bg-purple-500',
    fillColor: 'bg-purple-600',
  },
  {
    bgColor: 'bg-indigo-500',
    fillColor: 'bg-indigo-600',
  },
  {
    bgColor: 'bg-teal-500',
    fillColor: 'bg-teal-600',
  },
  {
    bgColor: 'bg-amber-500',
    fillColor: 'bg-amber-600',
  },
  {
    bgColor: 'bg-red-500',
    fillColor: 'bg-red-600',
  },
  {
    bgColor: 'bg-blue-500',
    fillColor: 'bg-blue-600',
  },
  {
    bgColor: 'bg-cyan-500',
    fillColor: 'bg-cyan-600',
  },
  {
    bgColor: 'bg-lime-500',
    fillColor: 'bg-lime-600',
  },
  {
    bgColor: 'bg-emerald-500',
    fillColor: 'bg-emerald-600',
  },
  {
    bgColor: 'bg-violet-500',
    fillColor: 'bg-violet-600',
  },
  {
    bgColor: 'bg-fuchsia-500',
    fillColor: 'bg-fuchsia-600',
  },
  {
    bgColor: 'bg-rose-500',
    fillColor: 'bg-rose-600',
  },
  {
    bgColor: 'bg-yellow-500',
    fillColor: 'bg-yellow-600',
  },
  {
    bgColor: 'bg-orange-300',
    fillColor: 'bg-orange-400',
  },
  {
    bgColor: 'bg-emerald-700',
    fillColor: 'bg-emerald-800',
  },
  {
    bgColor: 'bg-stone-500',
    fillColor: 'bg-stone-600',
  },
  {
    bgColor: 'bg-pink-300',
    fillColor: 'bg-pink-400',
  },
  {
    bgColor: 'bg-sky-700',
    fillColor: 'bg-sky-800',
  },
  {
    bgColor: 'bg-purple-700',
    fillColor: 'bg-purple-800',
  },
  {
    bgColor: 'bg-teal-300',
    fillColor: 'bg-teal-400',
  },
  {
    bgColor: 'bg-rose-300',
    fillColor: 'bg-rose-400',
  },
  {
    bgColor: 'bg-cyan-700',
    fillColor: 'bg-cyan-800',
  },
  {
    bgColor: 'bg-violet-300',
    fillColor: 'bg-violet-400',
  },
  {
    bgColor: 'bg-zinc-500',
    fillColor: 'bg-zinc-600',
  },
  {
    bgColor: 'bg-gray-500',
    fillColor: 'bg-gray-600',
  },
  {
    bgColor: 'bg-slate-500',
    fillColor: 'bg-slate-600',
  },
];
